import * as angular from "angular";
import {IController, IScope} from "angular";


export class ShipperAccountsViewCtrl implements IController {
  id: string;

  constructor(private $shipper, private $scope: IScope) {
  }

  $onInit() {
    this.$shipper(this.id).$bindCtrlToId(this.$scope, this, 'shipper', 'id');
  }

}

angular
  .module('bringoz.admin.shippers')
  .component('shipperAccountsView', {
    bindings: {
      id: '<'
    },
    template: require('./shipper-accounts-view.html').default,
    controller: ShipperAccountsViewCtrl
  });
